import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { take } from 'rxjs/operators';

import { ApiError, AuthService } from '../../../../core';
import { ClienteGrupoEconomicoSearchOrderBy } from '../../../../home/cliente-grupo-economico/cliente-grupo-economico-search-orderby';
import { ClienteGrupoEconomicoFilter } from '../../../../home/cliente-grupo-economico/filter';
import { ClienteGrupoEconomicoCrudHttpService } from '../../../../home/cliente-grupo-economico/services';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { ISelectOption } from '../select/models/select-option.interface';
import { ISelectSettings } from '../select/models/select-settings.interface';
import { ToastService } from '../toast/services/toast.service';

@Component({
  selector: 'sgt-novo-cliente-grupo-economico-select',
  templateUrl: './novo-cliente-grupo-economico-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NovoClienteGrupoEconomicoSelectComponent),
      multi: true
    }
  ]
})
export class NovoClienteGrupoEconomicoSelectComponent
  extends CustomControlValueAccessor<number> {
  @Input() variante: 'filtro' | undefined;

  private readonly _defaultSettings: Partial<ISelectSettings> = {
    placeholder: 'Nenhum Grupo Econômico',
    emptyResultMessage: 'Nenhum Grupo Econômico encontrado',
    isClearSelectionAllowed: true
  };
  private _settingsInput: Partial<ISelectSettings> = {};
  private _isLoading = false;
  private _settings: Partial<ISelectSettings> = { ...this._defaultSettings };

  @Input() set settings(value: Partial<ISelectSettings>) {
    this._settingsInput = value ?? {};
    this.recomporSettings();
  }
  get settings(): Partial<ISelectSettings> {
    return this._settings;
  }

  private recomporSettings(): void {
    this._settings = {
      ...this._defaultSettings,
      ...this._settingsInput,
      isLoading: this._isLoading
    };
  }

  private definirCarregando(carregando: boolean): void {
    this._isLoading = carregando;
    this.recomporSettings();
  }

  options: ISelectOption[] = [];
  selectedId: number | null = null;

  constructor(
    private authService: AuthService,
    private toastService: ToastService,
    private clienteGrupoEconomicoCrudHttpService: ClienteGrupoEconomicoCrudHttpService
  ) {
    super();
  }

  firstOpened(): void {
    if (this.options.length === 0) {
      this.load();
    }
  }

  private load(): void {
    this.definirCarregando(true);

    const filter = new ClienteGrupoEconomicoFilter();
    filter.situacao = 1;
    if (this.authService.isRepresentante()) {
      filter.idsRepresentantes = [this.authService.getIdRepresentante()];
    }

    this.clienteGrupoEconomicoCrudHttpService
      .searchWithFilter(
        filter,
        ClienteGrupoEconomicoSearchOrderBy.Nome,
        'asc',
        null,
        null
      )
      .pipe(take(1))
      .subscribe(
        (search) => {
          this.definirCarregando(false);
          this.options = (search?.entities ?? []).map((e) => ({
            id: e.id,
            label: e.nome
          }));
        },
        (error: ApiError) => {
          this.definirCarregando(false);
          this.toastService.error(error.message, { duration: 5000 });
        }
      );
  }

  onSelectionChange(): void {
    this.emitChange(this.selectedId);
  }

  protected updateValue(newValue: number | null): void {
    this.selectedId = newValue;
    if (newValue != null && this.options.length === 0) {
      this.load();
    }
  }
}
